import axiosInstance from "./axiosInstance";

export interface ChangePasswordPayload {
    old_password: string;
    new_password: string;
  }
  
  export const changePasswordRequest = async (
    payload: ChangePasswordPayload
  ): Promise<string> => {
    const response = await axiosInstance.post<{ message: string }>(
      "/change-password",
      payload
    );
    return response.data.message;
  };
    